import React from 'react';

export default function Help() {
  return (
    <>
      <h1 className="wp-portal__page-title">Help</h1>
      <p className="wp-portal__page-sub">Support and contact information.</p>
      <div className="wp-portal__empty">
        <p className="wp-portal__empty-label">
          For support, please contact your Woss Publishing representative
          directly. A help center will be available here in the future.
        </p>
      </div>
    </>
  );
}
